import { useState, useEffect } from "react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Loader2 } from "lucide-react";

export function CommLogDialog({ open, onOpenChange, customerId, contractId = "", onSaved }) {
  const [channel, setChannel] = useState("notiz");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) { setChannel("notiz"); setSubject(""); setBody(""); } }, [open]);

  const external = channel === "email" || channel === "whatsapp";

  const submit = async (e) => {
    e.preventDefault();
    if (!body.trim()) return toast.error("Bitte Inhalt eingeben");
    setSaving(true);
    try {
      const { data } = await api.post("/communication", { customer_id: customerId, contract_id: contractId, channel, subject, body });
      if (data.status === "entwurf_nicht_verbunden") toast.info("Als Entwurf gespeichert — Integration nicht verbunden. Keine Nachricht wurde versendet.");
      else toast.success("Kommunikation protokolliert");
      onSaved?.();
      onOpenChange(false);
    } catch (err) { toast.error(apiError(err)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader><DialogTitle>Kommunikation erfassen</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5"><Label>Kanal</Label>
            <Select value={channel} onValueChange={setChannel}>
              <SelectTrigger data-testid="comm-channel-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="notiz">Notiz</SelectItem>
                <SelectItem value="anruf">Anruf</SelectItem>
                <SelectItem value="email">E-Mail (Entwurf)</SelectItem>
                <SelectItem value="whatsapp">WhatsApp (Entwurf)</SelectItem>
              </SelectContent>
            </Select>
          </div>
          {external && <p className="rounded-md bg-amber-500/10 px-3 py-2 text-xs text-amber-700 dark:text-amber-300">Hinweis: {channel === "email" ? "E-Mail" : "WhatsApp"} ist noch nicht verbunden. Der Text wird nur als Entwurf gespeichert und NICHT versendet.</p>}
          {external && <div className="space-y-1.5"><Label>Betreff</Label><Input value={subject} onChange={(e) => setSubject(e.target.value)} /></div>}
          <div className="space-y-1.5"><Label>Inhalt</Label><Textarea rows={4} value={body} onChange={(e) => setBody(e.target.value)} data-testid="comm-body-input" /></div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Abbrechen</Button>
            <Button type="submit" className="bg-accent text-accent-foreground hover:bg-accent/90" disabled={saving} data-testid="comm-save-button">
              {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Speichern
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
